/* eslint-disable no-unused-vars */
import {
  jwt,
  bcrypt,
  paypal,
  nodemailer,
  stripe,
  cloudinary,
  tailwindcss,
  buynomain,
  ghermain,
  framermotion,
  jonathan,
  waleed,
  usama,
  hala,
  mohsin,
  swiper,
  learneazymain,
  monetramain,
} from "../assets";

export const projectsData = [
  {
    id: 0,
    title: "Monetra",
    role: "Full Stack AI Integration Developer",
    description:
      "AI-powered expense tracking SaaS for Pakistan with voice-first input, multilingual support, and real-time analytics for inclusive personal finance.",
    fullDescription: `Monetra is a voice-first expense tracking SaaS designed for Pakistani users who face language barriers and difficulty typing in Urdu. I developed the full-stack platform with AI voice recognition, multilingual support, and real-time analytics, enabling users to track expenses via Urdu or English voice commands and receipt uploads seamlessly.`,

    url: "https://smart-money-tracker.vercel.app",
    mainimage: monetramain,
    technologies: [
      {
        name: "React",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
      },
      {
        name: "ExpressJS",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg",
      },
      {
        name: "Translation & Localization",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
      },
      {
        name: "Google APIs",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/google/google-original.svg",
      },
      {
        name: "MongoDB",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
      },
    ],
    features: [
      "Voice-first expense input supporting Urdu, Hindi, and English for faster, low-friction daily finance tracking",
      "Receipt scanning with Google Gemini AI to extract transactions and auto-log entries with category context",
      "Interactive analytics dashboard with charts and expense breakdowns for instant spending visibility",
      "Full PKR currency support, local merchant recognition, and bilingual interface optimized for Pakistani users",
      "How it works: upload receipt or voice note -> AI processing with UpliftAI + Gemini -> instant transaction insights",
      'Example flow: "Grocery mein paanch sau rupay kharcha kiya" logs PKR 500 into the groceries category',
    ],
    challenges: [
      "42% of Pakistani adults are illiterate or struggle with English-first interfaces",
      "Typing Urdu on mobile devices is slow and frustrating for consistent financial logging",
      "Most finance apps lack reliable voice input and exclude users who are not comfortable typing",
      "Global products typically miss local currency behavior and Pakistani merchant recognition",
    ],
    solutions: [
      "Built multilingual AI voice capture and parsing to support Urdu, Hindi, and English expense logging",
      "Integrated Gemini-powered receipt extraction to reduce manual data entry and improve speed",
      "Designed mobile-first UI flows focused on simplicity and quick actions for everyday users",
      "Implemented PKR-native handling with local merchant-aware transaction categorization",
      "Delivered inclusive product experience that broadens access to digital personal finance in Pakistan",
    ],
  },
  {
    id: 1,
    title: "Learneazy",
    description:
      "A Learning Management System with VidoCipher secure video protection, Stripe payments, and enrollment analytics for instructors to sell courses without piracy concerns.",
    fullDescription: `Learneazy solves the critical problem of video content piracy in online education. Instructors can upload courses knowing their content is protected by VidoCipher's DRM technology, while students access materials through secure authentication. The platform handles course purchases, user roles, and provides detailed analytics on enrollment and revenue. Built with Next.js and Express.js, it supports multi-role dashboards for students, instructors (administrators).`,
    url: "https://learneazy.vercel.app",
    github: "https://github.com/ahadalireach/learneazy",
    mainimage: learneazymain,
    technologies: [
      {
        name: "Next.js",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg",
      },
      {
        name: "TypeScript",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg",
      },
      { name: "Tailwind CSS", icon: tailwindcss },
      {
        name: "Material-UI",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/materialui/materialui-original.svg",
      },
      {
        name: "Redux Toolkit (Query)",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg",
      },
      {
        name: "React Hot Toast",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
      },
      {
        name: "Formik",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
      },
      {
        name: "Yup",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
      },

      {
        name: "Express.js",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg",
      },
      {
        name: "MongoDB",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
      },
      {
        name: "Redis",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redis/redis-original.svg",
      },
      { name: "JWT", icon: jwt },
      { name: "Bcrypt", icon: bcrypt },
      {
        name: "NextAuth.js",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg",
      },
      {
        name: "VidoCipher",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
      },
      { name: "Stripe", icon: stripe },
      { name: "Cloudinary", icon: cloudinary },
      {
        name: "Socket.io",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/socketio/socketio-original.svg",
      },
      { name: "NodeMailer", icon: nodemailer },
      {
        name: "Recharts",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
      },
      {
        name: "Vercel",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vercel/vercel-original.svg",
      },
    ],
    features: [
      "DRM-protected video streaming with VidoCipher API to prevent content piracy and unauthorized downloads",
      "Multi-role authentication supporting students and instructors with JWT and social login integration",
      "Course creation platform with drag-drop curriculum builder and instant Stripe payment-to-enrollment integration",
      "Real-time notifications via Socket.io with advanced course filtering, search, and responsive dark/light mode design",
      "Analytics dashboard using Recharts for enrollment metrics, revenue tracking, and user management insights",
      "Interactive learning tools including Q&A system, reviews, and course completion tracking with milestones",
    ],
    challenges: [
      "Preventing video piracy while maintaining streaming performance across all devices and browsers",
      "Building secure payment workflows with automated enrollment and role-based access control",
      "Creating scalable analytics that handle real-time data synchronization between client and server",
    ],
    solutions: [
      "Integrated VidoCipher DRM with OTP-based validation for secure, piracy-resistant video streaming",
      "Built Stripe webhook integration with JWT authentication middleware for secure automated course enrollment",
      "Implemented Redis caching with optimized database queries for real-time analytics performance",
    ],
  },
  {
    id: 2,
    title: "Buyno",
    description:
      "A multi-vendor marketplace where independent sellers run their own stores with real-time messaging, payment processing, and admin tools to compete with major e-commerce platforms.",
    fullDescription: `Buyno addresses the complexity of managing multiple vendors in a single marketplace. Each vendor operates their own store with complete control over products, pricing, and customer interactions, while the platform handles payment processing, order management, and dispute resolution. The system includes real-time messaging between buyers and sellers, automated withdrawal processing for vendors, and comprehensive admin tools for platform oversight. Built with React.js and Express.js, it supports role-based dashboards for buyers, vendors, and administrators.`,
    url: "https://buyno.vercel.app",
    github: "https://github.com/ahadalireach/buyno",
    mainimage: buynomain,

    technologies: [
      {
        name: "React.js",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
      },
      {
        name: "Tailwind CSS",
        icon: tailwindcss,
      },
      {
        name: "Redux Toolkit",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg",
      },
      {
        name: "React Toastify",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
      },
      {
        name: "Express.js",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg",
      },
      { name: "JWT", icon: jwt },
      { name: "Bcrypt", icon: bcrypt },
      {
        name: "MongoDB",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
      },
      {
        name: "Socket.io",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/socketio/socketio-original.svg",
      },
      { name: "Stripe", icon: stripe },
      { name: "Cloudinary", icon: cloudinary },
      { name: "PayPal", icon: paypal },
      {
        name: "Vercel",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vercel/vercel-original.svg",
      },
    ],
    features: [
      "Multi-vendor store management with independent product catalogs, pricing control, and order fulfillment tracking",
      "Real-time messaging system between buyers and sellers supporting text, images, and order-specific communications",
      "Automated payment processing with Stripe, PayPal, and COD options plus vendor-specific coupon code integration",
      "Role-based authentication with email verification, JWT sessions, and protected routes for buyers, vendors, and admins",
      "Vendor earnings dashboard with withdrawal requests, payout method configuration, and payment processing",
      "Admin oversight tools including user management, vendor approval, withdrawal processing, and platform-wide analytics",
    ],
    challenges: [
      "Preventing fraudulent vendor registrations while maintaining legitimate seller access to the platform",
      "Managing real-time messaging at scale with proper message delivery and role-based communication controls",
      "Handling multiple products from different vendors in single orders with reliable payment distribution and commission tracking",
    ],
    solutions: [
      "Implemented email OTP verification with vendor identity checks to ensure only legitimate sellers can create stores",
      "Built Socket.io infrastructure with room-based messaging and JWT role validation for secure buyer-vendor communications",
      "Developed automated system that enables multi-party order placement with Stripe Connect for payment splitting to respective vendors",
    ],
  },
  //   {
  //     id: 3,
  //     title: "KisanBazar",
  //     description:
  //       "A hackathon-winning agricultural marketplace eliminating middlemen between farmers and buyers, built in 5 hours during a university competition.",
  //     fullDescription: `KisanBazar tackles the critical problem of farmers receiving unfair prices due to middleman exploitation in agricultural supply chains. This hackathon-winning solution connects farmers directly with consumers, allowing producers to set their own prices and build direct relationships with buyers. The platform includes farmer profile verification, messaging system, and order management systems designed specifically for agricultural commerce. Built with React.js and Express.js during a 5-hour hackathon, it demonstrates rapid full-stack development capabilities. Won first place at University of South Asia's Full Stack Web Development Hackathon.`,
  //     url: "https://kisanbazar.vercel.app",
  //     github: "https://github.com/ahadalireach/kisanbazar",
  //     mainimage: kisanbazarmain,

  //     technologies: [
  //       {
  //         name: "React.js",
  //         icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
  //       },
  //       {
  //         name: "Tailwind CSS",
  //         icon: tailwindcss,
  //       },
  //       {
  //         name: "Redux Toolkit",
  //         icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg",
  //       },
  //       {
  //         name: "React Toastify",
  //         icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
  //       },
  //       {
  //         name: "Express.js",
  //         icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg",
  //       },
  //       { name: "JWT", icon: jwt },
  //       { name: "Bcrypt", icon: bcrypt },
  //       {
  //         name: "MongoDB",
  //         icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
  //       },
  //       {
  //         name: "Vercel",
  //         icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vercel/vercel-original.svg",
  //       },
  //     ],
  //     features: [
  //       "Direct farmer-to-consumer marketplace with verified producer profiles and transparent pricing controls",
  //       "Messaging system enabling direct communication between farmers and buyers for order negotiations",
  //       "Product listing management with seasonal availability tracking, category filtering, and regional search capabilities",
  //       "Secure authentication system with JWT sessions and role-based access for farmers, consumers, and administrators",
  //       "Order placement and cart management specifically designed for agricultural products with quantity-based pricing",
  //       "Mobile-responsive interface optimized for farmers with limited digital literacy using visual-first design patterns",
  //     ],
  //     challenges: [
  //       "Creating an accessible interface for farmers with limited digital experience while maintaining full functionality",
  //       "Building trust between farmers and consumers in a direct-transaction model without traditional intermediaries",
  //       "Developing a complete full-stack agricultural marketplace within the 5-hour hackathon time constraint",
  //     ],
  //     solutions: [
  //       "Designed visual-first UI with large buttons, clear icons, and minimal text using Tailwind CSS for farmer accessibility",
  //       "Implemented verified farmer profiles with photo uploads and direct messaging to establish credibility and transparency",
  //       "Leveraged AI-assisted coding and rapid prototyping to architect a complete marketplace within 5-hour constraints, demonstrating efficient planning and execution under pressure",
  //     ],
  //     stats: {
  //       linesOfCode: "15k+",
  //       components: "12+",
  //       apiEndpoints: "30+",
  //       collections: "6",
  //       firebaseCollections: "0",
  //     },
  //     videoUrl: "https://www.youtube.com/embed/riaSSccA8uk?si=u4JZS8B1-fdPB3AS",
  //     testimonial: {
  //       name: "Waleed Ahmad",
  //       role: "Scaling B2B creators",
  //       text: "Ahad blew our expectations out of the park. With a super quick turnaround time and extreme attention to detail, he designed and developed our platform perfectly.",
  //       img: waleed,
  //     },
  //     architectureImages: {
  //       database: kisanbazardatabase,
  //     },
  //   },
  {
    id: 4,
    title: "Gher.com",
    description:
      "A full-stack real estate platform with advanced property filtering, secure authentication, and admin management tools for buying, selling, and renting properties.",
    fullDescription: `Gher.com addresses the challenge of finding the right property in a cluttered real estate market. Users can search properties with detailed filters including location, price range, room type, and amenities, while property owners manage their listings through secure dashboards. The platform features role-based access control for regular users and administrators. Built with React.js and Express.js, it integrates Firebase for authentication and image storage, providing a property management solution with EmailJS contact forms.`,
    url: "https://gher.vercel.app",
    github: "https://github.com/ahadalireach/gher.com",
    mainimage: ghermain,

    technologies: [
      {
        name: "React.js",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
      },
      {
        name: "Tailwind CSS",
        icon: tailwindcss,
      },
      {
        name: "Redux Toolkit",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg",
      },
      {
        name: "React Toastify",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
      },
      {
        name: "Express.js",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg",
      },
      { name: "JWT", icon: jwt },
      { name: "Bcrypt", icon: bcrypt },
      {
        name: "MongoDB",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
      },
      {
        name: "Firebase",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg",
      },
      {
        name: "Vercel",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vercel/vercel-original.svg",
      },
    ],
    features: [
      "Multi-condition property filtering with location, price, room type, and amenity-based search capabilities",
      "Secure user authentication and property management using Firebase integration with JWT validation",
      "Complete CRUD operations for property listings with image upload and profile management functionality",
      "Role-based access control with dedicated admin dashboard for user and listing management",
      "Direct property owner contact system through EmailJS integration for inquiry management",
    ],
    challenges: [
      "Building a property search system that handles simultaneous filters (location, price, type, amenities) without causing slow query performance",
      "Preventing unauthorized property modifications while maintaining legitimate owner access",
      "Managing high-resolution property images with Google authentication and fast loading across different network conditions",
    ],
    solutions: [
      "Implemented MongoDB compound queries with debounced React state updates to enable real-time filtering without database overload",
      "Built JWT middleware with property ownership verification to ensure users can only edit their own listings while admins access all records",
      "Integrated Firebase Authentication with Storage for Google sign-in and automatic image compression for secure, optimized property galleries",
    ],
  },
];

export const testimonialData = [
  {
    id: 1,
    name: "Jonathan Keim",
    role: "CEO",
    description:
      "After 6 months of bad hires, I’m grateful to have finally met Ahad. Someone who is a proficient in his communication as he is his development skills. I plan to work with him long term.",
    img: jonathan,
    size: "tall",
    color: "blue",
    pos: 1, // Col 1, R1-2
  },
  {
    id: 2,
    name: "Waleed Ahmad",
    role: "Scaling B2B creators",
    description:
      "Working with Ahad was straightforward and productive. He delivered our product exactly as expected.",
    img: waleed,
    size: "small",
    pos: 3, // Col 2, R2 (Center)
  },
  {
    id: 3,
    name: "Hala",
    role: "Senior Mentor",
    description:
      "Ahad is absolutely phenomenal! He has a knack for understanding your needs and creating visual designs that bring them to life.",
    img: hala,
    size: "small",
    pos: 4, // Col 3, R1 (On top of Usama)
  },
  {
    id: 4,
    name: "Usama",
    role: "Founder",
    description:
      "Amazing to work with, top quality and communicated effectively throughout the whole project. I am very grateful and happy with the work, definitely will use Ahad again!",
    img: usama,
    size: "tall",
    pos: 5, // Col 3, R2-3
  },
  {
    id: 5,
    name: "Mohsin",
    role: "Fractional Executive",
    description:
      "Great experience working with Ahad! Responsive, great quality and a pleasure to deal with. Check his work out... I think you'll dig it!",
    img: mohsin,
    size: "small",
    pos: 6, // Col 1, R3
  },
];

export const faqData = [
  {
    id: 1,
    question: "Who is your ideal client?",
    answer:
      "I work best with high-caliber founders, startups, and agency owners who need a reliable partner to take full ownership of their technical product from design to deployment.",
  },
  {
    id: 2,
    question: "What does 'Single Point of Ownership' mean for my project?",
    answer:
      "It means zero handoffs. You don't need a designer, a frontend dev, and a backend dev. I handle the Figma design, full-stack engineering, AI integrations, and marketing automations all by myself.",
  },
  {
    id: 3,
    question: "What is the typical timeline for a production-ready MVP?",
    answer:
      "A complete production-ready MVP usually ships in 4-6 weeks. Smaller, specialized automation or AI integration projects can be delivered in as little as 10-14 days.",
  },
  {
    id: 4,
    question: "How do you handle pricing and project costs?",
    answer:
      "I operate on a project-based pricing model. This ensures transparency and predictability, you know exactly what you're paying for and what you'll get, with no hidden hourly surprises.",
  },
  {
    id: 5,
    question: "Can you integrate AI and custom CRM automations?",
    answer:
      "Absolutely. I specialize in integrating OpenAI/ChatGPT into existing platforms and building complex GHL/CRM automation workflows that drive real business results.",
  },
];

export const processData = [
  {
    id: 1,
    step: "01",
    title: "Strategy & Discovery",
    description:
      "I dive deep into your business goals and market landscape to define a clear technical roadmap that ensures your product's success.",
  },
  {
    id: 2,
    step: "02",
    title: "BeSpoke Design",
    description:
      "Crafting a premium, high-converting UI/UX in Figma that doesn't just look good, but drives user engagement and trust.",
  },
  {
    id: 3,
    step: "03",
    title: "Deep Engineering",
    description:
      "Bringing the design to life with scalable code, robust AI integrations, and high-performance backend architecture.",
  },
  {
    id: 4,
    step: "04",
    title: "Automation & Launch",
    description:
      "Ship your production-ready MVP to the world and integrate marketing automations to start scaling your user base immediately.",
  },
];
